import { record } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { Resolver } from 'react-hook-form';

type CustomValidationError = Mews.TextKey;
type ValidationResult<V extends object> = Record<keyof V, CustomValidationError> | undefined;

type Validate<V extends object> = (
    values: V,
    fieldNames: Array<keyof V>
) => Promise<ValidationResult<V>> | ValidationResult<V>;

/**
 * This helper purpose is to prepare `resolver` prop for `Form` and `useFormControls` hook.
 */
export const createFormResolver =
    <V extends object>(validate: Validate<V>): Resolver<V> =>
    async (values, _context, { fields }) => {
        const mountedFields = pipe(
            fields,
            record.filter(({ mount }) => !!mount)
        );
        const fieldNames = Object.keys(mountedFields) as Array<keyof V>;
        const errors = await validate(values, fieldNames);

        return { values, errors: errors || {} };
    };
